import Header from "./Components/Header";
import SectionTwo from "./Components/SectionTwo";
import Showcase from "./Components/Showcase";

function App() {
  return (
    <>
      <Header />
      <Showcase />
      <SectionTwo />
    </>
  );
}

export default App;
